const styles = ({ BREAKPOINTS }) => ({
  container: {
    maxWidth: '1320px',
    padding: '0 20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    [`@media (max-width: ${BREAKPOINTS.XL})`]: {
      maxWidth: '1024px'
    }
  }
})

export default styles
